import { numberMoney } from 'Data/format.js'

export function getDescription(value) {
  let downpayment =
    value.downpayment_type === 'amount'
      ? numberMoney(value.downpayment)
      : value.downpayment_type === 'percentage'
        ? `${value.downpayment}%`
        : ''

  return `${downpayment} downpayment${FREQUENCIES[value.frequency]}`
}

let FREQUENCIES = {
  None: '',
  Weekly: ', weekly installments',
  EverySecondWeek: ', payments every second week',
  TwicePerMonth: ', twice per month installments',
  Monthly: ', monthly installments',
}
